import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum ListInquirySearchCondition {
  specificSearch = '1',
  detailSearch = '2',
}

const nameConfig = {
  specificSearch: new Map([
    [Locale.ja, '特定の条件で探す'],
    [Locale.en, 'Search with Specific Conditions'],
  ]),

  detailSearch: new Map([
    [Locale.ja, '詳細な条件を指定して探す'],
    [Locale.en, 'Search with Detailed Conditions'],
  ]),
};

const toEnum = rawValueToEnum(ListInquirySearchCondition, ListInquirySearchCondition.specificSearch);
const toDisplay = enumToName(ListInquirySearchCondition, nameConfig);
const toDisplayWithPrefix = enumToName(ListInquirySearchCondition, nameConfig, { prefix: true });

export const listInquirySearchCondition = {
  enum: ListInquirySearchCondition,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ListInquirySearchCondition };
